/**
 * Recolecta archivos .xml de una selección de carpeta o de arrastrar/soltar.
 * Asigna webkitRelativePath cuando falta (p. ej. drag-and-drop) para activar multi-año.
 */

function isXmlFile(file) {
  return Boolean(file?.name && String(file.name).toLowerCase().endsWith(".xml"));
}

function withRelativePath(file, relativePath) {
  if (!file || !relativePath) return file;
  if (file.webkitRelativePath) return file;
  try {
    Object.defineProperty(file, "webkitRelativePath", {
      value: relativePath,
      configurable: true,
    });
  } catch {
    /* algunos navegadores no permiten redefinir */
  }
  return file;
}

async function readEntryFiles(entry, prefix, out) {
  if (entry.isFile) {
    await new Promise((resolve) => {
      entry.file(
        (file) => {
          if (isXmlFile(file)) {
            out.push(withRelativePath(file, prefix ? `${prefix}/${file.name}` : file.name));
          }
          resolve();
        },
        () => resolve(),
      );
    });
    return;
  }
  if (!entry.isDirectory) return;

  const reader = entry.createReader();
  const batch = [];
  await new Promise((resolve) => {
    const readChunk = () => {
      reader.readEntries(
        (entries) => {
          if (!entries.length) {
            resolve();
            return;
          }
          batch.push(...entries);
          readChunk();
        },
        () => resolve(),
      );
    };
    readChunk();
  });

  for (const child of batch) {
    const childPrefix = prefix ? `${prefix}/${child.name}` : child.name;
    await readEntryFiles(child, childPrefix, out);
  }
}

/** Lista plana de XML desde FileList (input webkitdirectory o múltiples archivos). */
export function xmlFilesFromFileList(files) {
  return Array.from(files || []).filter(isXmlFile);
}

/** Recolecta XML desde DataTransfer (arrastrar carpeta o archivos al drop zone). */
export async function xmlFilesFromDataTransfer(dataTransfer) {
  const out = [];
  const items = dataTransfer?.items;
  if (items?.length) {
    const entries = [];
    for (let i = 0; i < items.length; i += 1) {
      const item = items[i];
      if (item.kind !== "file") continue;
      const entry = item.webkitGetAsEntry?.();
      if (entry) entries.push(entry);
      else {
        const file = item.getAsFile();
        if (isXmlFile(file)) out.push(file);
      }
    }
    for (const entry of entries) {
      await readEntryFiles(entry, entry.name || "", out);
    }
  } else if (dataTransfer?.files?.length) {
    for (const file of dataTransfer.files) {
      if (isXmlFile(file)) out.push(file);
    }
  }
  return out;
}

/** true si al menos un archivo trae ruta relativa (carpeta / drop recursivo). */
export function folderUploadHasRelativePaths(files) {
  return Array.isArray(files) && files.some((f) => Boolean(f?.webkitRelativePath));
}
